import React from 'react';
import Icon from '../../../components/AppIcon';

const TrackingSearch = ({ value, onChange, placeholder }) => {
  return (
    <div className="relative">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <Icon name="Search" size={20} className="text-muted-foreground" />
      </div>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e?.target?.value)}
        placeholder={placeholder}
        className="w-full pl-10 pr-4 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
      />
      {value && (
        <button
          onClick={() => onChange('')}
          className="absolute inset-y-0 right-0 pr-3 flex items-center"
        >
          <Icon name="X" size={16} className="text-muted-foreground hover:text-foreground" />
        </button>
      )}
    </div>
  );
};

export default TrackingSearch;